import React, { useState } from 'react'
import styles from './Header.module.scss'
import { Link, useNavigate } from 'react-router-dom';
// import { headerIndexState } from '../../recoils/Header';
import { useRecoilState } from 'recoil';
import MoveHeader from '../../hooks/MoveHeader';

const Header = () => {
    // const [header, setHeader] = useRecoilState(headerState);
    const navigate = useNavigate();
    const {headerIndex, setHeaderIndex} = MoveHeader();

    const navItem = [
        { name: '서비스', path: '/'},
        { name: '체험하기', path: '/experience'},
        // { name: '광고ㆍ홍보', path: '/ad'}
    ];

    const moveTo = (path:string, index:number) => {
        setHeaderIndex(index);
        navigate(path);
    };
  
    return (
        <div className={styles.header}>
            <div className={styles.wrap}>
                <div className={styles.left}>
                    <div className={styles.logo} />
                    <div className={`${styles.nav} body2 medium gs7`}>
                    {
                        navItem.map((item, index)=>{
                            return <div key={index} onClick={()=>{moveTo(item.path, index)}} className={headerIndex === index ? `${styles.item} ${styles.active}` : styles.item } >{item.name}</div>
                        })
                    }
                    </div>
                </div>
                <div className={styles.right}>
                    <div onClick={()=>{moveTo("/inquire", 4)}}className={`${styles.inquiry} body3 bold wh`  }>도입 문의하기</div>
                </div>
            </div>
        </div>
    )
}

export default Header
